import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminApi, errMsg } from "@/lib/api";
import { PageTitle, Btn, Panel } from "@/admin/ui";
import { ImageField } from "@/admin/ProductDialogs";
import { ChangePasswordPanel } from "@/admin/ChangePasswordPanel";

const FIELDS = [
  ["upi_id", "UPI ID (shown for UPI & bank transfer)"],
  ["bank_account_name", "Account holder name"],
  ["bank_account_number", "Account number"],
  ["bank_ifsc", "IFSC"],
  ["bank_name", "Bank / branch"],
  ["support_phone", "Support phone"],
  ["store_address", "Store address"],
  ["notice", "Storefront notice banner (leave empty to hide)"],
  ["summary_whatsapp", "WhatsApp number for nightly sales summary (empty = support phone)"],
  ["upi_qr", "UPI QR image"],
];

export default function AdminSettings() {
  const [f, setF] = useState(null);
  useEffect(() => { adminApi.get("/settings").then((r) => setF(r.data)); }, []);
  const save = async () => {
    try { setF((await adminApi.put("/settings", Object.fromEntries(FIELDS.map(([k]) => [k, f[k] || ""])))).data); toast.success("Settings saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!f) return <p className="text-stone-500">Loading…</p>;
  return (
    <div className="max-w-2xl">
      <PageTitle sub="Payment details shown to customers at checkout.">Settings</PageTitle>
      <Panel title="Payment & support" testId="settings-panel">
        <div className="space-y-3">
          {FIELDS.map(([k, l]) => (
            <div key={k} className="space-y-1">
              <Label className="text-xs font-bold uppercase text-stone-500">{l}</Label>
              {k === "upi_qr" ? <ImageField value={f.upi_qr} onChange={(v) => setF({ ...f, upi_qr: v })} testId="setting-upi-qr" />
                : <Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-9" data-testid={`setting-${k}`} />}
            </div>
          ))}
          <Btn onClick={save} data-testid="settings-save-btn">Save settings</Btn>
        </div>
      </Panel>
      <ChangePasswordPanel />
    </div>
  );
}
